import forcyteService from './ForcyteService'

const BASE_URL = 'donor-portal/v2'

class GuestService {
  async confirmGuestAppointment(payload) {
    return forcyteService.post(`${BASE_URL}/guest/confirm-appointment`, payload)
  }
}

const guestService = new GuestService()
export default guestService
